import { Inject, Component, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs';
import swal from 'sweetalert2';

import { PrincipalinventoryService } from "../../../services/principalinventory.service";
import { ReportService } from '../../../services/report.service';
import { UserService } from '../../../services/user.service';

import { DinamicData, Cell } from '../../../models/dinamic-data';

import { formatDate } from '@angular/common';

import { Methods } from '../../../shared/methods';
declare const $: any;
@Component({
  selector: 'app-remove-hard-drives',
  templateUrl: './remove-hard-drives.component.html',
  styleUrls: ['./remove-hard-drives.component.css'],
  providers: [ReportService]
})
export class RemoveHardDrivesComponent implements OnInit {

  public mtds: Methods = new Methods();

  public loading: boolean = false;

  //Identidad del usuario
  public identity;
  public token;

  //public saving = false; 

  public bulk: Array<number> = [];

  public multipleData: DinamicData = new DinamicData(
    ['check', 'Manufacturer', 'Model', 'Serial Number', 'Status']
  )

  /*DISCOS DUROS RECIBIDOS PARA INTEGRAR A LA TABLA*/
  public diskDrivers;

  /*PHYSICALDESTRUCTION REPORT*/
  public po;
  public clientsname;
  public arrayDiscs: any[] = [];
  public reportId;
  public typeReport;

  public statusRemoveHardDrive = null;

  constructor(
    public dialogRef: MatDialogRef<RemoveHardDrivesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _router: Router,
    public dialog: MatDialog,
    private _service: PrincipalinventoryService,
    private _reportService: ReportService,
    private _userService: UserService
  ) {    

    this.token = this._userService.getToken();
    this.identity = this._userService.getIdentity();
    this.diskDrivers = data.diskdrives;
    this.po = data.po;
    this.clientsname = data.clientsname;
  }

  ngOnInit() {

    this.getData();

  }

  close() {

    this.dialogRef.close();

  }

  checkBulk(param){
    
    /*console.log(this.multipleData.rows[1][0].grayed);
    console.log(this.multipleData.rows[1][4].value);
    this.multipleData.rows[1][4].value = 'DESTROYED';
    console.log(this.multipleData.rows[1][4].value);
    this.multipleData.rows[1][0].grayed = true;*/

    if(this.bulk.length === 0){

      this.statusRemoveHardDrive = null;  

      for(let d of this.multipleData.rows){

        if(d[4].value !== 'DESTROYED')
          d[0].grayed = false;
      }    
    }
          

    if(this.bulk.length === 1){
        
      const disk = this.multipleData.rows.find(element => element[0].value == param.value);

      this.statusRemoveHardDrive = disk[4].value;

      for(let d of this.multipleData.rows){

        if(d[4].value !== this.statusRemoveHardDrive)
          d[0].grayed = true;
      }
      
    } 

  }

  openModalRemove() {    

    const result = this.diskDrivers.find(({ recid }) => recid === Number(this.bulk[0]));

    if(result.hddErasureresults === "PARTIAL" || result.hddErasureresults === "FAILED")
      ($('#modalPartial') as any).modal('show');  
    else
    //$('#modalRemove').modal('show');
      ($('#modalRemove') as any).modal('show');
  }

  openModalReturn() {
    //$('#modalRemove').modal('show');
    ($('#modalReturn') as any).modal('show');
  }

  removeHardDrives(action){

    ($('#modalRemove') as any).modal('hide');
    ($('#modalPartial') as any).modal('hide'); 

    let json = {
      destroyed: action,
      bulk: this.bulk
    }  

    /*if(action === 1)
      this.openModalCheckReport();*/

    this._service.removeHardDrives(json).subscribe(
      response => {

        if(response.status === 'success'){

          if(action !== 1){
            this.showSwal('success', 'Removed!', 'Hard drive has been removed successfully');
            this.dialogRef.close();
          }
           
          if(action === 1)
            this.checkReport();
            //this.openModalCheckReport();

        } else{
          this.showSwal('error', 'ERROR!', response.msg);
        }

      }, error => {
        console.log("error");
      }

    );
  }

  /*openModalCheckReport() {
    
    ($('#modalCheckReport') as any).modal('show');
  }*/

  checkReport(){

    //($('#modalCheckReport') as any).modal('hide');

    /*var typeReport;

    if(type === 'basic')
      typeReport = 'PDTEMP';
    else
      typeReport = 'DETAILEDPHYSICALDESTRUCTION';*/

    let json = {
      //type: typeReport,
      po: this.po
    }  

    this._reportService.checkPOReport(this.token, json).subscribe(
      response => {

        this.typeReport = response.typeReport;

        if(response.status === 'success'){

          //OBTENGO EL ID DEL REPORTE
          this.reportId = response.data.id;

          //GUARDO LOS DISCOS
          this.saveDisk();

          // SI ESTÁ COMPLETADO MANDO LLAMAR EL REPORT UPDATE PARA LA NOTIFICACIÓN
          if(response.data.completed === 1)
            this.reportUpdate();

        } else{
          
          this.saveDestructionReport();

        }

      }, error => {
        console.log("error");
      }

    );
  }

  reportUpdate(){    

    let fechaHoy = formatDate(new Date(), 'MM/dd/yyyy', 'en');
    //let type = 'PDTEMP';
    
    let dataEnviar = {
      "user_id": this.identity.sub,
      "po": this.po,
      "name": fechaHoy,
      //"type": type === 'detail' ? "DETAILEDPHYSICALDESTRUCTION" : "PHYSICALDESTRUCTION",
      "type": this.typeReport,
      "data": ''
    }

    this._reportService.update(this.token, this.reportId, dataEnviar).subscribe(
      response => {
        
        if (response.status == 'success') {
          
        }
      },
      error => {
        console.log(<any>error);
      });
  }

  saveDestructionReport() {
    
    let fechaHoy = formatDate(new Date(), 'MM/dd/yyyy', 'en');
    //let type = 'PDTEMP';

    let dataEnviar = {
      user_id: this.identity.sub,
      po: this.po,
      name: fechaHoy,
      type: this.typeReport === 'DETAILEDPHYSICALDESTRUCTION' ? "DETAILEDPHYSICALDESTRUCTION" : "PDTEMP",
      //type: this.typeReport,
      data: null
    };
    
    this._reportService.new(this.token, dataEnviar).subscribe(
      response => {
        if (response.code === 400 && response.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (response.status === 'success') {

          this.reportId = response.data.id;
          this.saveDisk();

        } else {
          this.mtds.notifyError(response.msg, response.code);
        }
      }, error => {
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  saveDisk() {    

    let disk;

    for (disk of this.bulk) {
      
      const result = this.diskDrivers.find(({ recid }) => recid === Number(disk));

      let idrandom = Math.floor((Math.random() * 100) + 1);
      let serialnumberenviar = result.hddSerialnumber;
      let erasuredateneviar = this.getFecha();

      let json: any = {
        id: idrandom,
        SerialNumber: serialnumberenviar,
        ErasureEndDate: erasuredateneviar,
        clientsname: this.clientsname
      }

      if (this.typeReport === 'DETAILEDPHYSICALDESTRUCTION') {
        json = {
          id: idrandom,
          make: result.hddManufacturer,
          model: result.hddModel,
          capacity: result.hddCapacity,
          SerialNumber: serialnumberenviar,
          ErasureEndDate: erasuredateneviar,
          clientsname: this.clientsname
        }
      }

      this.arrayDiscs.push(json);

    }

    this._reportService.enviarDiscoBulk(this.token, this.reportId, this.arrayDiscs).subscribe(
      response => {
        console.log(response);
        if (response.code === 400 && response.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (response.status === 'success') {
          
          //REVISAR SI HAY DISCOS QUE YA ESTÁN EN EL REPORTE

          let serialNumberRepeated: string = 'Hard drive has been removed and destroyed successfully \n';

          if(response.data !== 'success'){

            serialNumberRepeated = serialNumberRepeated + 'Serial number already exists on the report: \n'

            for (let sn of response.data) {
              serialNumberRepeated = serialNumberRepeated + sn + ', ';
            }

            serialNumberRepeated = serialNumberRepeated.slice(0, -2);

            this.showSwal('success', 'Destroyed!', serialNumberRepeated);
          }else {
            this.showSwal('success', 'Destroyed!', 'Hard drive has been destroyed successfully');
          }

          this.dialogRef.close();

        } else {
          this.mtds.notifyError(response.msg, response.code);
        }
        
      }, error => {
        this.mtds.notifyError(error.statusText, error.status);
        
      }
    );
  }

  /*returnDiks(){

    let disk;

    for (disk of this.bulk) {
      
      const result = this.diskDrivers.find(({ recid }) => recid === disk);

      this.arrayDiscs.push(result.hddSerialnumber);

      if(result.reportId !== null)
        this.reportId = result.reportId;

    }

    this._reportService.borrarDiscoBulk(this.token, this.reportId, this.arrayDiscs).subscribe(
      response => {
        console.log(response);
        if (response.code === 400 && response.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (response.status === 'success') {
                    
           this.checkIDReport();

        } else {
          this.mtds.notifyError(response.msg, response.code);
        }
        
      }, error => {
        this.mtds.notifyError(error.statusText, error.status);
        
      }
    );
  }

  checkIDReport(){

    let json = {
      report_id: this.reportId
    }  

    this._reportService.checkPOReport(this.token, json).subscribe(
      response => {        

        if(response.status === 'success'){

          // SI ESTÁ COMPLETADO MANDO LLAMAR EL REPORT UPDATE PARA LA NOTIFICACIÓN
          if(response.data.completed === 1){

            this.reportUpdate();
          }

        }

      }, error => {
        console.log("error");
      }

    );
  }*/


  returnStatus(){

    ($('#modalReturn') as any).modal('hide');

    let json = {
      bulk: this.bulk
    }  

    this._service.returnStatusHardDrives(json).subscribe(
      response => {

        console.log(response);

        if(response.status === 'success'){

          this.showSwal('success', 'Returned!', 'Hard drive has been returned to the device');

          //this.returnDiks();

          this.dialogRef.close();

        } else{
          this.showSwal('error', 'ERROR!', response.msg);
        }

      }, error => {
        console.log("error");
      }

    );
  }

  getData(){

    this.diskDrivers.forEach(
      function (element) {

        let color;
        let grayed: boolean = false;

        if(element.hddErasureresults === 'PASSED')
          color = 'green';
        if(element.hddErasureresults === 'PARTIAL')
          color = 'orange';
        if(element.hddErasureresults === 'FAILED')
          color = 'red';
        if(element.hddErasureresults === 'DESTROYED'){
          color = 'red';
          grayed = true;
        }
        if(element.hddErasureresults === 'REMOVED')
          color = 'red';

        this.multipleData.rows.push(
          [
            new Cell(element.recid, {type: 'checkbox', grayed}),
            new Cell(element.hddManufacturer),
            new Cell(element.hddModel),
            new Cell(element.hddSerialnumber),            
            new Cell(element.hddErasureresults, {class: 'fw-bold', color })
          ]
        );

      }.bind(this)
    );    
  }

  getFecha(){

    var fecha = new Date();

    let currentHours = fecha.getHours();
    let currentHoursText = ("0" + currentHours).slice(-2);
    let currentMinutes = fecha.getMinutes();
    let currentMinutesText = ("0" + currentMinutes).slice(-2);
    let currentSeconds = fecha.getSeconds();
    let currentSecondsText = ("0" + currentSeconds).slice(-2);

    let dia;
    dia = fecha.getDate();
    let day;
    if (dia < 10) {
      day = '0' + dia;
    } else {
      day = dia;
    }
    let mes;
    mes = fecha.getMonth() + 1;
    let month;
    if (mes < 10) {
      month = '0' + mes;
    } else {
      month = mes;
    }
    const anio = fecha.getFullYear();

    const hour = fecha.getTime();

    //console.log(month + '/' + day + '/' + anio + ' ' + currentHoursText + ':' + currentMinutesText + ':' + currentSecondsText);
    return(month + '/' + day + '/' + anio + ' ' + currentHoursText + ':' + currentMinutesText + ':' + currentSecondsText);
  }

  showSwal(type, title = '', message = '') {
    if (type === 'success') {
        swal.fire({
         
            title: title,
            text: message,
            buttonsStyling: false,
           customClass:{
    confirmButton: 'btn btn-success'
            },

        });

    } else if (type === 'error') {
        swal.fire({
       
          title: title,
          text: message,
          buttonsStyling: false,
         customClass:{
    confirmButton: 'btn btn-success'
            },

        });
    }
  }

}